/*
 * First Light — working sticky header.
 * The theme's native position:sticky is defeated by the body (display:grid +
 * the scroll container, which also swallows scroll events). Pin the header with
 * position:fixed (.fl-header-fixed in custom.css) once a sentinel placed between
 * the promo bar and the header scrolls out of the viewport. IntersectionObserver
 * watches the viewport directly, so it works regardless of the scroll container.
 * A spacer fills the header's vacated space (no content jump); the promo bar above
 * the sentinel never moves, so there is no feedback loop. Deferred + retry so it
 * runs after the header hydrates.
 */
(function () {
  function setup() {
    var header = document.querySelector('.header-section.sticky-header');
    if (!header) return false;
    if (header.dataset.flSticky) return true;
    if (!('IntersectionObserver' in window)) return true;
    header.dataset.flSticky = '1';

    var spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.display = 'none';
    header.parentNode.insertBefore(spacer, header.nextSibling);

    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'width:100%;height:1px;pointer-events:none;';
    header.parentNode.insertBefore(sentinel, header);

    new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) {
          spacer.style.height = header.offsetHeight + 'px';
          spacer.style.display = 'block';
          header.classList.add('fl-header-fixed');
        } else {
          header.classList.remove('fl-header-fixed');
          spacer.style.display = 'none';
        }
      },
      { threshold: 0 }
    ).observe(sentinel);
    return true;
  }

  if (!setup()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (setup() || ++tries > 40) clearInterval(iv);
    }, 200);
    window.addEventListener('load', setup);
  }
})();

/*
 * First Light — stale section-anchor shim (2026-07-17).
 * Anchor links saved in template settings point at
 * #shopify-section-template--<numeric-id>__<section-key>, but the numeric id is
 * regenerated on every theme duplication, so saved links go stale and clicks
 * silently no-op (hero "4.8 from 200+ reviews", homepage "See how each root
 * works" CTA, legacy ad-landing "Order now" buttons). The section-key suffix IS
 * stable across duplications — resolve stale anchors by suffix instead of
 * hand-repointing numeric ids after every duplication.
 */
(function () {
  function resolveStale(hash) {
    var m = /^#(shopify-section-template--\d+(__[A-Za-z0-9_-]+))$/.exec(hash || '');
    if (!m || document.getElementById(m[1])) return null;
    return document.querySelector('.shopify-section[id$="' + m[2] + '"]');
  }
  function jump(el) {
    el.style.scrollMarginTop = '100px'; /* matches .shopify-section:target */
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#shopify-section-template--"]');
    if (!a) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    var el = resolveStale(url.hash);
    if (el) { e.preventDefault(); jump(el); }
  });
  /* Cross-page navigations land here with the stale hash still in the URL
     (script is deferred, so the DOM is ready by now). Lazy media above the
     target can expand after the first jump and push it out of view, so
     re-align once everything has loaded. */
  var stale = resolveStale(location.hash);
  if (stale) {
    jump(stale);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () {
        setTimeout(function () { jump(stale); }, 80);
      });
    }
  }
})();
